import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

// reactstrap
import { Card, CardBody, CardTitle, CardSubtitle, Button, Row, Col, Form, FormGroup, Label, Input } from 'reactstrap'

// components
import Loading from '../../components/Loading/Loading';
import TituloLogin from './components/TituloLogin';

//api
import usuario_api from '../../api/usuario_api';
import acesso_api from '../../api/acesso_api';

// helpers
import { showMessage } from '../../helpers/message';
import { removeAllCookies } from '../../helpers/cookies';

// views
import Modulos from './Modulos';
import { useAuth } from '../../context/auth';

export default function Login() {
    //context
    const { signIn, signOut, setupVariavel } = useAuth();
    
    const navigate = useNavigate();

    // Function to clear complete cache data
    const clearCacheData = () => {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
    };

    useEffect(() => {
        removeAllCookies();
        clearCacheData();
    }, []);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            login: '',
            senha: ''
        }
    });

    // Controla exibição do loading
    const [loading, setLoading] = useState(false);

    // Submit do formulário, para validar a autenticação
    const onSubmit = (data) => {
        const json_submit = {
            username: data.login,
            password: data.senha
        }

        setLoading(true);
        usuario_api.authenticate(json_submit).then(result => {
            if (result.status !== 200) {
                setLoading(false);
                showMessage("Aviso", result.message, "error");
            } else if (result.data == null) {
                setLoading(false);
                showMessage("Aviso", "Usuário/Senha não encontrado", 'warning', null);
            }
            else {
                if (result?.data?.perfil == "Integrador Externo") {
                    setLoading(false);
                    showMessage("Aviso", "Usuário com perfil de Integrador Externo não possui acesso ao sistema.", 'warning', null);
                    return;
                }

                signIn(result.data);
                Acesso(result.data);
            }
        })
            .catch(e => {
                setLoading(false);
                showMessage("Aviso", e.message, "error", null);
            })
    }

    // Armazena os acessos do usuário para selecionar no componente de módulos
    const [acessos, set_acessos] = useState(null);

    // Retorna os módulos de acesso que o usuário possui
    const Acesso = (usuario) => {
        acesso_api.get()
            .then(result => {
                setLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, "error");
                } else {
                    if (!result.data) {
                        showMessage("Aviso", "Seu usuário não pode acessar nenhum módulo do sistema", "error");
                        return;
                    }
                    let _acesso = usuario;
                    if (result.data.length == 1) {
                        _acesso.acesso = {
                            sigla: result.data[0].sigla,
                            modulo: result.data[0].modulo,
                        }

                        if (_acesso.acesso.modulo != "Gestor" && _acesso.acesso.modulo != "Fiscal") {
                            _acesso.acesso.acesso_id = result.data[0].acessos[0].id;
                            _acesso.acesso.acesso_descricao = result.data[0].acessos[0].descricao;
                            _acesso.acesso.somenteConsulta = result.data[0].acessos[0].somenteConsulta === true;
                        }

                        signIn(_acesso);
                        navigate(`/admin/inicio`);
                    }
                    else {
                        set_acessos(result.data);
                    }
                }
            })
            .catch(e => {
                setLoading(false);
                showMessage("Aviso", e.message, "error");
            });
    }

    // Evento OnChange de todos os campos Input
    function onChangeInput(e) {
        const { name, value } = e.target;
        setValue(name, value);
    }

    const handleReturnModulos = () => {
        set_acessos(null);
        signOut();
    }

    return (
        <div>
            {loading && (<Loading />)}
            {acessos && <Modulos acessos={acessos} handleReturn={handleReturnModulos}></Modulos>}
            {!acessos &&
                <Card style={{ marginTop: "10vh" }}>
                    <CardBody >
                        <Row className='mt-3 pl-3'>
                            <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center'>
                                <TituloLogin></TituloLogin>
                            </Col>
                            <Col lg='6' md='12' className='text-left'>
                                <CardTitle tag={'h4'} className='fw-normal text-center'>Dados de acesso</CardTitle>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <FormGroup className='text-left'>
                                        <Label className='font-weight-light label'>
                                            Usuário
                                        </Label>
                                        <Input id="login" type="login" invalid={errors.login ? true : false} {...register("login", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                        {errors.login && <span className={"form-control-label text-danger"}>{errors.login.message}</span>}
                                    </FormGroup>
                                    <FormGroup className='text-left'>
                                        <Label className='font-weight-light label'>
                                            Senha
                                        </Label>
                                        <Input id="senha" type="password" invalid={errors.senha ? true : false} {...register("senha", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                        {errors.senha && <span className={"form-control-label text-danger"}>{errors.senha.message}</span>}
                                    </FormGroup>
                                    <div className='text-center text-lg-start d-flex align-items-center justify-content-between'>
                                        <a onClick={() => navigate(`/auth/esqueceusenha`)} href="" className="text-secondary">Recuperar Senha</a>

                                        {setupVariavel && 
                                            !!setupVariavel.quemCadastraGeradores && 
                                            (setupVariavel.quemCadastraGeradores == "Gerador" || setupVariavel.quemCadastraGeradores == "Secretaria/Gerador" || setupVariavel.quemCadastraGeradores == "Secretaria/Transportador/Gerador") &&
                                            <div onClick={() => navigate("/auth/cadastros/geradores", { state: { cadastroExternoGerador: setupVariavel.quemCadastraGeradores } })} className='text-secondary' role='button'>Gerador, Cadastre-se <span className='fw-bold'>aqui!</span></div>
                                        }
                                    </div>
                                    <div className="mt-3 d-flex justify-content-center justify-content-lg-end">

                                        <Button type="submit" color='success' className='fw-bold px-4' >
                                            Entrar
                                        </Button>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            }
            {
                setupVariavel?.contatoPrefeitura &&
                <div
                    className='d-none d-md-block'
                    dangerouslySetInnerHTML={{ __html: setupVariavel?.contatoPrefeitura }}
                    style={{
                        width: "300px",
                        position: 'fixed',
                        bottom: '60px',
                        right: '20px',
                        zIndex: 999,
                        padding: "15px",
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0px 2px 2px rgba(0,0,0,0.4)",
                        boxSizing: "border-box",
                    }}
                ></div>
            }
        </div >
    )

}